import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { TrainingService } from '../training.service';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { CourseComponent } from '../course/course.component';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { Content, Landing, Settings } from '../../models/training-models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-training-section',
  templateUrl: './training-section.component.html',
  styleUrl: './training-section.component.scss',
  imports: [
    VideoPlayerComponent,
    MatExpansionModule,
    CourseComponent,
    CommonModule,
  ],
})
export class TrainingSectionComponent implements OnInit, AfterViewInit {
  private route = inject(Router);
  private ss = inject(SessionStorageService);
  private trainSvc = inject(TrainingService);

  @Input() section: string;
  @Input() settings: Settings;
  @Input() loadedVideo: string;
  @Output() videoChange = new EventEmitter();
  landingData: Landing;
  contentData: Content;

  ngOnInit(): void {
    if (this.trainSvc.currentApp() === 'landing') {
      this.landingData = this.settings.landing;
    } else {
      this.contentData = this.settings.content.find(contentItem => {
        return contentItem.app === this.trainSvc.currentApp();
      });
    }
  }

  ngAfterViewInit(): void {
    if (
      this.ss.get('RbTrainingVideoIndex') ||
      this.ss.get('RbTrainingVideoIndex') === 0
    ) {
      const videoElement = document.getElementById(
        `video-${this.ss.get('RbTrainingVideoIndex')}`
      );

      if (videoElement) {
        videoElement.focus();
      }

      this.ss.remove('RbTrainingVideoIndex');
    }
  }

  showCourse(rights): boolean {
    return this.trainSvc.rightsValid(rights);
  }

  showVideo(videoCode, videoIndex): void {
    this.ss.set('RbTrainingVideoIndex', videoIndex);
    this.loadedVideo = videoCode;
    this.videoChange.emit(videoCode);
    this.route.navigate([`/training/${this.section}/${videoCode}`]);
  }
}
